module.exports = __webpack_public_path__ + "static/media/Artists_and_Home_Users.f73a7d3c.svg";